import { IconButton, IconButtonProps, Tooltip } from '@chakra-ui/react';
import { SearchTab } from '@habity/types';
import { useTranslations } from 'next-intl';
import { FaLocationArrow } from 'react-icons/fa';
import { useFilters } from '~/hooks/useFilters';
import { useLocationSearch } from '~/hooks/useLocationSearch';
import { useHomesStore } from '~/store';

interface LocationIconButtonProps extends IconButtonProps {
  size?: string;
  color?: string;
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
  tab?: SearchTab;
}

export const LocationIconButton = ({
  size = 'md',
  color = 'blackAlpha.600',
  tooltipPlacement = 'bottom',
  tab,
  ...props
}: LocationIconButtonProps) => {
  const t = useTranslations('LocationSearch');
  const { isLoading, searchByCurrentLocation } = useLocationSearch();
  const filters = useHomesStore((state) => state.filters);
  const { longitude, latitude } = filters || {};
  const { performSearch } = useFilters();
  const locationSearchActive = !!longitude && !!latitude;

  const handleGetCurrentLocation = () => {
    if (locationSearchActive) {
      // Clear location filter from search
      performSearch({
        filters: { ...filters, longitude: null, latitude: null },
        tab,
      });
    } else {
      // Search by current location
      searchByCurrentLocation(tab);
    }
  };

  return (
    <Tooltip
      label={locationSearchActive ? t('dontUseMyLocation') : t('useMyLocation')}
      placement={tooltipPlacement}
    >
      <IconButton
        icon={<FaLocationArrow />}
        onClick={handleGetCurrentLocation}
        isLoading={isLoading}
        variant="secondary"
        flexShrink="0"
        size={size}
        color={longitude && latitude ? 'black' : color}
        _hover={{ color: 'black', bg: 'blackAlpha.50' }}
        _focus={{ color: 'blackAlpha.600' }}
        {...props}
        aria-label={
          locationSearchActive ? t('dontUseMyLocation') : t('useMyLocation')
        }
      />
    </Tooltip>
  );
};
